import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.scss']
})
export class CommentComponent implements OnInit {
  @Input() form:FormGroup;
  message:FormControl;
  constructor() { }

  ngOnInit() {
    this.message = this.form.get('message') as FormControl;
  }

}
